import IntoTab from './IntoTab.vue';

IntoTab.install = (Vue) => {
  Vue.component(IntoTab.name, IntoTab);
};

export default IntoTab;
